import { CLEAR_STATUS } from '@store/action-types/blog';

const clearStatus = () => ({ type: CLEAR_STATUS });

export default clearStatus;
